import React from 'react'

function Historia() {
  return (
    <div>Historia</div>
  )
}

export default Historia